// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","mainLayout":"App_mainLayout__8nQkU"};